/* =================== MODAL DE DEPOIMENTOS EM VÍDEO (VANILLA JS) =================== */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    const testimonialCards = document.querySelectorAll(".depoimento-card");
    const videoModal = document.getElementById("video-modal");
    const videoWrapper = videoModal ? videoModal.querySelector(".modal-video-wrapper") : null;
    const closeBtn = videoModal ? videoModal.querySelector(".modal-close-btn") : null;
    const overlay = videoModal ? videoModal.querySelector(".modal-overlay") : null;

    if (!testimonialCards.length || !videoModal || !videoWrapper || !closeBtn || !overlay) return;

    // Função para abrir o modal com o vídeo correspondente
    function openVideo(videoId) {
      // Injeta o iframe com autoplay do YouTube
      videoWrapper.innerHTML = `
        <iframe 
          src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&showinfo=0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen>
        </iframe>
      `;
      
      // Abre o modal
      videoModal.classList.add("active");
      videoModal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden"; // Impede scroll da página sob o modal
    }

    // Função para fechar o modal e limpar o iframe (parar o vídeo)
    function closeVideo() {
      videoModal.classList.remove("active");
      videoModal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = ""; // Restaura scroll
      
      // Esvazia o conteúdo para destruir o iframe e parar a execução do áudio/vídeo
      setTimeout(() => {
        videoWrapper.innerHTML = "";
      }, 300); // Aguarda o fim da transição do CSS
    }

    // Eventos nos cards
    testimonialCards.forEach((card) => {
      card.addEventListener("click", function () {
        const videoId = this.getAttribute("data-video-id");
        if (videoId) {
          openVideo(videoId);
        }
      });
    });

    // Evento de fechar no botão "X"
    closeBtn.addEventListener("click", closeVideo);

    // Evento de fechar ao clicar no overlay de fundo
    overlay.addEventListener("click", closeVideo);

    // Evento de fechar ao pressionar a tecla ESC
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && videoModal.classList.contains("active")) {
        closeVideo();
      }
    });
  });
})();

/* =================== CARROSSEL DE DEPOIMENTOS =================== */
$(function () {
  $(".carrossel-depoimentos").each(function () {
    const $carousel = $(this);
    const totalItens = $carousel.find(".splide__slide").length;

    const cols = {
      desktop: 3,
      tablet: 2,
      mobile: 1,
    };

    let carouselOpts = {
      type: "loop",
      perPage: cols.desktop,
      perMove: cols.desktop,
      gap: "30px", // Espaçamento original do grid no desktop
      arrows: true,
      pagination: true,
      breakpoints: {
        1200: {
          perPage: cols.tablet,
          perMove: cols.tablet,
          gap: "20px",
        },
        760: {
          perPage: cols.mobile,
          perMove: cols.mobile,
          gap: "20px",
        },
      },
    };

    if (
      (isMedia("desktop") && totalItens < cols.desktop) ||
      (isMedia("tablet") && totalItens < cols.tablet) ||
      (isMedia("mobile") && totalItens < cols.mobile)
    ) {
      $carousel.addClass("carousel-force-center");
      carouselOpts.type = "slide";
      carouselOpts.drag = false;
      carouselOpts.autoplay = false;
      carouselOpts.arrows = false;
    }

    let carousel = new Splide($carousel[0], carouselOpts);
    carousel.mount();
  });
});
